import { memo, useMemo, useRef, useState } from 'react'

import { CircleCrossIcon, SearchIcon } from '@Static/icons/ExchangePageIcons'

import { useOnClickOutside } from '@App/hooks'

import classes from './InputWithSelect.module.scss'
import { IInputWithSelectProps } from './interfaces'

const SelectArrow = memo((props: any) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" {...props}>
    <path d="M16.5 8.49v2.25L12 15.51l-4.5-4.77V8.49h9z" fill="currentColor" />
  </svg>
))

export default function InputWithSelect({
  selectItems,
  selectedValue,
  setSelectedValue,
  placeholder,
  register,
  errors,
}: IInputWithSelectProps) {
  const [isSelectOpened, setIsSelectOpened] = useState(false)
  const handleClickOutside = () => setIsSelectOpened(false)

  return (
    <>
      <div className={classes.container}>
        <input {...register} type="text" placeholder={placeholder ?? ''} />

        <div className={classes.selectButton} onClick={() => setIsSelectOpened(true)}>
          <div>{selectedValue}</div>
          <SelectArrow width={16} className={`${classes.arrow} ${isSelectOpened && classes.open}`} />
        </div>
      </div>
      {isSelectOpened && (
        <Select onOutsideClick={handleClickOutside} setSelectedValue={setSelectedValue} selectItems={selectItems} />
      )}
      {errors?.message ? <div className={classes.error}>{errors.message}</div> : null}
    </>
  )
}

export const Select = ({
  onOutsideClick,
  setSelectedValue,
  selectItems,
}: {
  onOutsideClick: () => void
  setSelectedValue: (value: string) => void
  selectItems: string[]
}) => {
  const [isFocus, setIsFocus] = useState(false)

  const [search, setSearch] = useState('')

  const filteredItems = useMemo(
    () => selectItems.filter((item) => item.toLowerCase().includes(search.toLowerCase())),
    [selectItems, search],
  )
  const selectRef = useRef(null)

  useOnClickOutside(selectRef, onOutsideClick)

  return (
    <div className={classes.select} ref={selectRef}>
      <div className={`${classes.inputContainer} ${isFocus ? classes.active : ''}`}>
        <SearchIcon className={classes.icon} width={20} />
        <input
          autoFocus
          type="text"
          name="name"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          onFocus={() => setIsFocus(true)}
          onBlur={() => setIsFocus(false)}
        />
        <div onClick={() => setSearch('')}>
          <CircleCrossIcon className={classes.icon} width={20} />
        </div>
      </div>
      <div className={classes.itemsContainer}>
        {filteredItems.map((item) => (
          <div
            key={item}
            className={classes.selectItem}
            onClick={() => {
              setSelectedValue(item)
              onOutsideClick()
            }}
          >
            {item}
          </div>
        ))}
      </div>
    </div>
  )
}
